var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 52,
    viewBox: "0 0 44 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.9,
    d: "M28.4297 5.09375V11.2188H0.757812V5.09375H11.0391V0.609375H18.9141V5.09375H28.4297ZM14.8672 12.6953C21.7578 12.6953 26.8984 16.7969 26.9531 22.4297C26.8984 27.8984 21.7578 32.0547 14.8672 32C8.14062 32.0547 3 27.8984 3 22.4297C3 16.7969 8.14062 12.6953 14.8672 12.6953ZM14.8672 18.6016C12.2422 18.6016 10.3281 19.9688 10.3281 22.4297C10.3281 24.7266 12.2422 26.0938 14.8672 26.0938C17.5469 26.0938 19.625 24.7266 19.625 22.4297C19.625 19.9688 17.5469 18.6016 14.8672 18.6016ZM43.0859 1.04688V32.9297H35.2656V27.9531H29.0312V21.7188H35.2656V18.1641H29.1953V11.9844H35.2656V1.04688H43.0859ZM43.0859 35.1172V51.25H35.2656V41.2969H8.41406V35.1172H43.0859Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText07);
export default __webpack_public_path__ + "static/media/text07.e6b2452bc242db067ee0db1e9c135d5c.svg";
export { ForwardRef as ReactComponent };